import moment from 'moment';
import React, { useMemo } from 'react';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Loading from '~/components/loading';
import ResultNotFound from '~/components/resultNotFound';
import TableList from '~/components/tableList';
import TitleApp from '~/components/title';
import useApi from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { AuthorizedIp } from '~/services/resource/authorizedIps/response';
import * as S from './styles';

const headerItems = [
  { id: 'locale', value: 'Local', maxChar: 30, textAlign: 'center' },
  { id: 'ipAddress', value: 'IP', maxChar: 22, textAlign: 'center' },
  { id: 'created', value: 'Data de criacao', maxChar: 22, textAlign: 'center' },
  { id: 'active', value: 'Ativo', maxChar: 12, textAlign: 'center' },
];

const AuthorizedIps: React.FC = () => {
  const authorizedIps = useApi<AuthorizedIp[]>({
    url: Endpoints.resource.getAuthorizedIps,
    fetchOnMount: true,
  });

  const items = useMemo(() => {
    return (authorizedIps.data || []).map((item, index) => [
      { type: 'id', value: `${item.ipAddress}-${index}` },
      { id: 'locale', value: item.locale || '-', textAlign: 'center' },
      { id: 'ipAddress', value: item.ipAddress || '-', textAlign: 'center' },
      {
        id: 'created',
        value: item.created
          ? moment(item.created).format('DD/MM/YYYY HH:mm')
          : '-',
        textAlign: 'center',
      },
      {
        id: 'active',
        value: (
          <S.Status active={item.active}>
            {item.active ? 'Sim' : 'Nao'}
          </S.Status>
        ),
        textAlign: 'center',
      },
    ]);
  }, [authorizedIps.data]);

  return (
    <Container>
      <Loading status={authorizedIps.loading} />
      <ContainerFlex>
        <TitleApp>IPs Autorizados</TitleApp>
        <S.BoxCard>
          {items.length > 0 ? (
            <TableList customerHeader={headerItems} list={items} />
          ) : (
            !authorizedIps.loading && <ResultNotFound />
          )}
        </S.BoxCard>
      </ContainerFlex>
    </Container>
  );
};

export default AuthorizedIps;
